export default __webpack_public_path__ + "static/media/1.3f02d3bc.png";